var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col justify-center h-52"},[_c('div',{staticClass:"text-center"},[_vm._v("\n    "+_vm._s(_vm.$i18nPresenter.t('Has no presentation to copy to.'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }